import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { logoutAndRedirect } from '../actions/user'

class RefreshApp extends Component {
  render() {
    const onClickBound = this.onClick.bind(this)
    return (
      <div id="refreshAppWrapper">
        <div id="refreshApp">
          Some changes to QuestMaker are available. Please save your work and
          update ASAP.
          <div className="button" onClick={onClickBound}>
            Update QuestMaker
          </div>
        </div>
      </div>
    )
  }

  onClick() {
    this.props.dispatch(logoutAndRedirect(true))
  }
}

RefreshApp.propTypes = {
  dispatch: PropTypes.func.isRequired
}

// purely to gain access to dispatch; could pass in from parent instead?
export const mapStateToProps = state => ({})

export default connect(mapStateToProps)(RefreshApp)
// pure component for testing
export { RefreshApp as RefreshAppDisconnected }



// WEBPACK FOOTER //
// ./src/components/RefreshApp.js